export const EMPRESA_PARCEIRA = 2;


// WEBPACK FOOTER //
// ./src/constants/empresaTipo.js